(function () {
    'use strict';

    angular
        .module('app.application')
        .run(appRun);

    /* @ngInject */
    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'application',
                config: {
                    url: '/application',
                    abstract: true,
                    template: '<ui-view/>',
                    ncyBreadcrumb: {
                        label: 'Application'
                    },
                    data: {
                        permissions: {
                            only: ['SSO:SysAdmin', 'SSO:AppAdmin'],
                            redirectTo: function () {
                                return {
                                    state: 'error.403',
                                    options: {
                                        reload: true
                                    }
                                };
                            }
                        }
                    }
                }
            },
            {
                state: 'application.dashboard',
                config: {
                    url: '/dashboard',
                    templateUrl: 'app/application/dashboard/application.dashboard.html',
                    controller: 'ApplicationDashboardController',
                    controllerAs: 'vm',
                    title: 'Application Dashboard',
                    ncyBreadcrumb: {
                        label: 'Dashboard'
                    },
                    settings: {
                        isVisible: true,
                        nav: 2,
                        content: '<i class="fa fa-dashboard"></i> Application Dashboard'
                    }
                }
            }
        ];
    }
})();
